import React from "react";
import { makeStyles } from "@material-ui/core";
import { motion } from "framer-motion";
import Link from "../../components/v2/Link";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import clsx from "clsx";
import SEO from "../../components/SEO";
import LazyImage from "../../components/v4/LazyLoadImage/LazyImage";
import FaqSection from "../../components/v4/FaqSection/FaqSection";

import partnerIcon1 from "../../images/v4/aiPage/icons/partnerIcon1.png";
import partnerIcon2 from "../../images/v4/aiPage/icons/partnerIcon2.png";
import partnerIcon3 from "../../images/v4/aiPage/icons/partnerIcon3.png";
import partnerIcon5 from "../../images/v4/aiPage/icons/partnerIcon5.png";
import partnerIcon6 from "../../images/v4/aiPage/icons/partnerIcon6.png";
import partnerIcon7 from "../../images/v4/aiPage/icons/partnerIcon7.png";
import partnerIcon8 from "../../images/v4/aiPage/icons/partnerIcon8.png";

import smartWorkflowImg1 from "../../images/v4/workflowAutomation/images/smartWorkflowImg1.png";
import smartWorkflowImg2 from "../../images/v4/workflowAutomation/images/smartWorkflowImg2.png";
import smartWorkflowImg3 from "../../images/v4/workflowAutomation/images/smartWorkflowImg3.png";
import smartWorkflowImg4 from "../../images/v4/workflowAutomation/images/smartWorkflowImg4.png";
import smartWorkflowImg5 from "../../images/v4/workflowAutomation/images/smartWorkflowImg5.png";

import workflowAutomationBg1 from "../../images/v4/workflowAutomation/images/workflowAutomationBg1.png";
import workflowAutomationBg2 from "../../images/v4/workflowAutomation/images/workflowAutomationBg2.png";
import workflowAutomationBg3 from "../../images/v4/workflowAutomation/images/workflowAutomationBg3.png";

import powerfulIcon1 from "../../images/v4/workflowAutomation/icons/powerfulIcon1.svg";
import powerfulIcon2 from "../../images/v4/workflowAutomation/icons/powerfulIcon2.svg";
import powerfulIcon3 from "../../images/v4/workflowAutomation/icons/powerfulIcon3.svg";
import powerfulIcon4 from "../../images/v4/workflowAutomation/icons/powerfulIcon4.svg";

import broadcastImg1 from "../../images/v4/workflowAutomation/images/broadcastImg1.png";
import broadcastImg2 from "../../images/v4/workflowAutomation/images/broadcastImg2.png";
import broadcastImg3 from "../../images/v4/workflowAutomation/images/broadcastImg3.png";

import benefitBg from "../../images/v4/workflowAutomation/images/benefitBg.webp";

import whiteCheckCircle from "../../images/v4/whatsappPage/icons/whiteCheckCircle.svg";

import leadIcon from "../../images/v4/workflowAutomation/icons/leadIcon.svg";
import eventsIcon from "../../images/v4/workflowAutomation/icons/eventsIcon.svg";
import seasonalIcon from "../../images/v4/workflowAutomation/icons/seasonalIcon.svg";
import reminderIcon from "../../images/v4/workflowAutomation/icons/reminderIcon.svg";
import feedbackIcon from "../../images/v4/workflowAutomation/icons/feedbackIcon.svg";
import recordsIcon from "../../images/v4/workflowAutomation/icons/recordsIcon.svg";
import tagIcon from "../../images/v4/workflowAutomation/icons/tagIcon.svg";
import realTimeIcon from "../../images/v4/workflowAutomation/icons/realTimeIcon.svg";
import arrow from "../../images/v4/workflowAutomation/icons/arrow.svg";

import gmailIcon from "../../images/v4/workflowAutomation/icons/gmailIcon.svg";
import officeIcon from "../../images/v4/workflowAutomation/icons/officeIcon.svg";
import whatsappIcon from "../../images/v4/workflowAutomation/icons/whatsappIcon.svg";
import workFlowImg from "../../images/v4/workflowAutomation/images/workFlowImg.png";
import workflowAutomationHero from "../../images/v4/workflowAutomation/images/workflowAutomationHero.webp";
import bodySectionBg from "../../images/v4/workflowAutomation/images/bodySectionBg.png";
import supportBoxBg from "../../images/v4/workflowAutomation/images/supportBoxBg.png";
import TruestedSection from "../../components/v4/TrustedSection/TruestedSection";
import TestimonialSlider from "../../components/v3/TestimonialSlider/TestimonialSlider";
import trustedSectionBg from "../../images/v4/workflowAutomation/images/trustedSectionBg.png";

const useStyles = makeStyles((theme) => ({
  heroSection: {
    background: "#04111c",
    backgroundImage:
      "radial-gradient(at 61% 19%, hsla(207,75%,6%,1) 0px, transparent 50%),radial-gradient(at 42% 17%, hsla(262,63%,20%,1) 0px, transparent 50%),radial-gradient(at 20% 18%, hsla(207,75%,6%,1) 0px, transparent 50%),radial-gradient(at 86% 21%, hsla(256,39%,24%,1) 0px, transparent 50%),radial-gradient(at 4% 93%, hsla(265,66%,23%,1) 0px, transparent 50%);",
    paddingTop: "100px",
    "& .container": {
      paddingBottom: "0",
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: 0,
    },
  },
  heroSectionInner: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "32px",
    width: "70%",
    margin: "0 auto",
    textAlign: "center",
    "& .highlight": {
      background: "linear-gradient(96deg, #9cd1ff 1%, #ba77f0 99%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    "& .heroPoints": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "20px",
    },
    "& .point": {
      gap: "10px",
      display: "flex",
      minWidth: "max-content",
      alignItems: "center",
      justifyContent: "flex-start",
      borderRadius: "50px",
      background: "hsla(0,0%,100%,.1)",
      padding: "10px 15px",
      border: "1px solid #8E7DE1",
    },
    marginBottom: "64px",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      // textAlign: "left",
      "& .heroPoints": {
        flexDirection: "column",
        width: "80%",
        // justifyContent: "flex-start",
        alignItems: "stretch",
      },
    },
  },
  bodySection: {
    backgroundImage: `url(${bodySectionBg})`,
    backgroundPosition: "top",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "60%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
        marginTop: "50px",
      },
      "& .containerInner": {
        paddingTop: 0,
        paddingBottom: 0,
      },
    },
  },
  partnerSlide: {
    width: "144px !important",
    "& img": {
      width: "144px",
      filter: "brightness(0.1)",
    },
    "@media only screen and (max-width: 600px)": {
      width: "max-content !important",
      "& img": {
        width: "100px",
      },
      // marginRight: "20px !important",
    },
  },
  partnerSlider: {
    padding: "10px 0 60px !important",
    "@media only screen and (max-width: 600px)": {
      paddingBottom: "40px !important",
    },
  },
  featureContainerInner: {
    width: "70%",
    margin: "0 auto",
    background: "#fff",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "24px",
    padding: "24px",
    borderRadius: "24px",
    boxShadow: "0 31px 49.1px 0 #e7caff;",
    position: "relative",
    top: "-160px",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      top: "unset",
      padding: "15px",
    },
  },
  featureContainerInnerBody: {
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "center",
    rowGap: "24px",
    "@media only screen and (max-width: 600px)": {
      gap: "15px",
      rowGap: "15px",
    },
  },
  workflowFeatureContainer: {
    width: "23%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: "10px",
    textAlign: "center",
    alignItems: "center",
    padding: "16px",
    border: "1px solid #c0cfdd",
    borderRadius: "16px",
    // "& img": {
    //   padding: "10px",
    //   borderRadius: "8px",
    // },
    "& p": {
      width: "80%",
    },
    "@media only screen and (max-width: 600px)": {
      width: "47%",
    },
  },
  supportBox: {
    width: "100%",
    display: "flex",
    padding: "40px",
    background: "#0e314d",
    backgroundImage: `url(${supportBoxBg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    alignItems: "center",
    borderRadius: "20px",
    backdropFilter: "blur(30px)",
    justifyContent: "space-between",
    "& $broadcastLeftContainer": {
      width: "45%",
      gap: "20px",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      width: "100%",
      padding: "15px",
      marginTop: "20px",
      gap: "20px",
      "& $cardPointer": {
        alignItems: "center",
      },
    },
  },
  pointers: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "24px",
  },
  cardPointer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "15px",
    "@media only screen and (max-width: 600px)": {
      alignItems: "center",
    },
  },
  growingBusiness: {
    // background: "#2F0056",
    paddingBottom: "65px",
    position: "relative",
    "& .header": {
      width: "55%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      textAlign: "left",
      gap: "32px",
    },
    "& $featureContainer": {
      gap: "32px",
    },
    "@media only screen and (max-width: 600px)": {
      paddingBottom: "170px",
    },
    "@media only screen and (max-width: 600px)": {
      paddingBottom: 0,
      "& .header": {
        width: "100%",
      },
    },
  },
  featureContainer: {
    position: "relative",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    width: "32%",
    gap: "22px",
    // boxShadow: "0px 0px 16px #C1D7DB66",
    borderRadius: "16px",
    background: "#fff",
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    textAlign: "left",
    overflow: "hidden",
    transition: "0.3s ease",
    minHeight: "370px",
    "& p": {
      width: "90%",
    },
    "& .absoluteImg": {
      position: "absolute",
      bottom: "0px",
      width: "90%",
      transition: "0.3s ease",
    },
    "&:hover .absoluteImg": {
      bottom: "-500px",
    },
    "& $pointers": {
      visibility: "hidden",
      opacity: "0",
      transition: "0.3s ease",
    },
    "&:hover $pointers": {
      visibility: "visible",
      opacity: "1",
    },
    "@media only screen and (max-width: 600px)": {
      width: "80%",
      minHeight: "300px",
      "& p": {
        width: "100%",
      },
    },
  },
  performanceSection: {
    background: "#401960",
    "& $integrationLeft": {
      width: "50%",
    },
    "@media only screen and (max-width: 600px)": {
      "& $integrationLeft": {
        width: "100%",
      },
    },
  },
  statsContainer: {
    display: "flex",
    alignItems: "stretch",
    justifyContent: "space-between",
    width: "100%",
    marginTop: "60px",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "15px",
    },
  },
  statsBox: {
    width: "24%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "20px",
    background: "#310059",
    borderRadius: "15px",
    padding: "20px",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "15px",
    },
  },
  statsBoxBody: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    "& .border": {
      border: "1px solid #FFFDFD40",
    },
    "& ul": {
      paddingLeft: "18px",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      "& ul": {
        paddingLeft: "18px",
      },
      "& li": {
        marginBottom: "10px",
      },
    },
  },
  statsFont: {
    fontSize: "80px",
  },
  integrationHeader: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "30px",
    },
  },
  integrationLeft: {
    width: "50%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  integrationRight: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    position: "relative",
    width: "40%",
    gap: "20px",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      overflow: "hidden",
    },
  },
  cardsLayout: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "20px",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
    },
  },
  cards: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "20px",
  },
  card: {
    gap: "8px",
    padding: "16px",
    background: "#fff",
    borderRadius: "8px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    cursor: "pointer",
    "& img": {
      borderRadius: "8px",
      boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.2)",
    },
    "@media only screen and (max-width: 600px)": {
      width: "70%",
    },
  },
  benefitSection: {
    padding: "100px 0",
    "& $integrationHeader": {
      alignItems: "center",
    },
    "@media only screen and (max-width: 600px)": {
      padding: 0,
    },
  },
  commonPageFooterSection: {
    background: "#031e31",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
  broadcastLeftContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "50%",
    gap: "32px",
    textAlign: "left",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  broadcastRightContainer: {
    width: "50%",
    "& img": {
      width: "100%",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      "& img": {
        width: "100%",
      },
    },
  },
  broadcastImg: {
    "& img": {
      width: "100%",
      position: "relative",
      bottom: "0",
    },
  },
  broadcastBox: {
    display: "flex !important",
    padding: "32px",
    background: "#009249",
    alignItems: "center",
    borderRadius: "20px",
    justifyContent: "space-between",
    minWidth: "80%",
    maxWidth: "80%",
    minHeight: "360px",
    transition: "0.3s ease",
    "&.active": {
      transform: "scale(1) !important",
    },
    "&.inActive": {
      transform: "scale(0.8) !important",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "15px",
      gap: "15px",
      flexDirection: "column",
      minHeight: "600px",
    },
  },
  cardPointer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "10px",
    "@media only screen and (max-width: 600px)": {
      alignItems: "center",
    },
  },
  broadcastContainerInner: {
    width: "100%",
    display: "flex",
    position: "relative",
    alignItems: "flex-start",
    gap: "30px",
    padding: "0 8rem 4rem !important",
    overflow: "auto",
    justifyContent: "flex-start",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "0 15px 40px !important",
    },
    "@media only screen and (min-width: 1900px)": {
      padding: "0 20rem 4rem !important",
    },
  },
  broadcastLeftContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "42%",
    gap: "10px",
    textAlign: "left",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  broadcastRightContainer: {
    width: "45%",
    "& img": {
      width: "100%",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      "& img": {
        width: "100%",
      },
    },
  },
  broadcastImg: {
    "& img": {
      width: "100%",
      position: "relative",
      bottom: "0",
    },
  },
  workflowBroadcastContainerInner: {
    width: "100%",
    display: "flex",
    position: "relative",
    alignItems: "stretch",
    gap: "30px",
    padding: "0 4rem 4rem !important",
    overflow: "auto",
    justifyContent: "flex-start",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "0 15px 40px !important",
    },
    "@media only screen and (min-width: 1900px)": {
      padding: "0 19rem 6rem !important",
    },
    "& .swiper-wrapper": {
      alignItems: "stretch",
    },
  },
  broadcastContainer: {
    backgroundColor: "hsla(272,83%,11%,1)",
    backgroundImage:
      "radial-gradient(at 0% 100%, hsla(273,73%,22%,1) 0px, transparent 50%),radial-gradient(at 94% 36%, hsla(273,73%,22%,1) 0px, transparent 50%)",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "78%",
      margin: "0 auto",
      textAlign: "center",
    },
    "& $broadcastRightContainer": {
      width: "40%",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
      },
      "& $broadcastRightContainer": {
        width: "100%",
      },
    },
  },
  tag: {
    padding: "12px 20px",
    border: "1px solid #fff",
    borderRadius: "50px",
  },
  wpFaq: {
    "@media only screen and (max-width: 600px)": {
      "& section": {
        padding: "0px 0 0 !important",
      },
    },
  },
  cardHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "& img:last-child": {
      padding: 0,
      border: 0,
      boxShadow: "none",
    },
  },
  integrationBg: {
    position: "absolute",
    zIndex: "-1",
    top: "-30%",
    left: "-5%",
    height: "unset",
    transform: "translate(-2%, 4%)",
    "@media only screen and (max-width: 600px)": {
      top: "0%",
      left: "-90px",
      transform: "none",
    },
  },
  statIcon: {
    // padding: "10px 12px",
    // borderRadius: "8px",
  },
  belowText: {
    width: "100%",
    textAlign: "right",
    color: "#9279B1",
    marginTop: "10px",
  },
  trustedSection: {
    background: "#fff",
  },
}));

const WorkflowAutomation = () => {
  const classes = useStyles();

  const partners = [
    { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
    { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
    { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
    { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
    {
      icon: partnerIcon6,
      alt: "mustard seed systems corporation - Pepper Cloud Customer",
    },
    {
      icon: partnerIcon7,
      alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
    },
    { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
    { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
    { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
    { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
    { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
    {
      icon: partnerIcon6,
      alt: "mustard seed systems corporation - Pepper Cloud Customer",
    },
    {
      icon: partnerIcon7,
      alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
    },
    { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
  ];

  const featureList = [
    {
      icon: leadIcon,
      desc: "Lead management",
      color: "#ff8958",
    },
    {
      icon: eventsIcon,
      desc: "Event and task management",
      color: "#9e5ad5",
    },
    {
      icon: seasonalIcon,
      desc: "Seasonal greetings",
      color: "#ffb54b",
    },
    {
      icon: reminderIcon,
      desc: "Reminder notifications",
      color: "#208eec",
    },
    {
      icon: feedbackIcon,
      desc: "Feedback collection",
      color: "#ffb54b",
    },
    {
      icon: recordsIcon,
      desc: "Record updation",
      color: "#009a99",
    },
    {
      icon: tagIcon,
      desc: "Tag-based communication",
      color: "#ff8958",
    },
    {
      icon: realTimeIcon,
      desc: "Real-time notifications",
      color: "#9e5ad5",
    },
  ];

  const statsBoxContent = [
    {
      heading: "Reduction in errors",
      number: "80%",
      content:
        "Automate processes for consistent accuracy, eliminating costly human errors, and boost operational reliability.",
      color: "#FFDFD2",
      icon: powerfulIcon1,
      iconBg: "#ff8350",
    },
    {
      heading: "Boost in efficiency",
      number: "77%",
      content:
        "Improve operational efficiency by automating lead capture, routing conversations, task assignments, and more.",
      color: "#F1DFFF",
      icon: powerfulIcon2,
      iconBg: "#ffb54b",
    },
    {
      heading: "Revenue increased",
      number: "66%",
      content:
        "Automate data entry, follow-ups, and more, freeing up your team to focus on growth-driving activities",
      color: "#CEE9FF",
      icon: powerfulIcon3,
      iconBg: "#9e5ad5",
    },
    {
      heading: "Customer rating",
      number: "30%",
      content:
        "Reduce team size and cut down expenses by automating payment reminders, using AI chatbots to handle routine queries.",
      color: "#BEE7E7",
      icon: powerfulIcon4,
      iconBg: "#02ae7f",
    },
  ];

  const growingList = [
    {
      points: [
        "Choose from readymade templates to automate processes.",
        "Customise workflows to match your business needs.",
        "Track performance with real-time analytics.",
      ],
      background: workflowAutomationBg1,
      img: smartWorkflowImg1,
      alt: "ready-made workflow templates",
      heading: "Ready-to-use workflow templates for instant setup",
      text: "Manage leads, track deals, automate workflows, and communicate across multiple channels from a single platform.",
    },
    {
      points: [
        "Assign tasks to the right team members based on expertise.",
        "Prioritise critical tasks to ensure timely actions.",
        "Eliminate manual task management and focus on growth.",
      ],
      background: workflowAutomationBg2,
      img: smartWorkflowImg2,
      alt: "Auto task assignment",
      heading: "Smart task assignment and prioritisation",
    },
    {
      background: workflowAutomationBg3,
      img: smartWorkflowImg3,
      alt: "Auto lead management and follow up workflows",
      heading: "Seamless lead management and follow-ups",
      points: [
        "Capture leads automatically from multiple channels.",
        "Auto-trigger personalised follow-ups and reminders.",
        "Reduce response time and convert leads faster.",
      ],
    },
    {
      background: workflowAutomationBg1,
      img: smartWorkflowImg4,
      alt: "Customisable workflows",
      heading: "Customisable workflows - Triggers, conditions, and actions",
      points: [
        "Set up time-based triggers to send reminders, seasonal greetings, etc.",
        "Define event-based triggers to activate when leads hit key milestones.",
        "Set up multiple conditions for one trigger and perform actions easily.",
      ],
    },
    {
      background: workflowAutomationBg3,
      img: smartWorkflowImg5,
      alt: "data-driven analysis workflows",
      heading: "Data-driven automation with analytics",
      points: [
        "Analyse workflow performance with detailed reports.",
        "Optimise processes based on conversion rates and completion metrics.",
        "Make informed decisions to maximise ROI.",
      ],
    },
  ];
  const broadcastList = [
    {
      tag: "Sales and marketing",
      heading: "Accelerate conversions with automation",
      content:
        "Maximise impact and efficiency by streamlining promotional campaigns. Increase sales conversions with automated lead nurturing, follow-ups, and task assignments.",
      img: broadcastImg1,
      alt: "sales and marketing workflows",
      background: "linear-gradient(179deg, #B74AF5 0%, #5E02A8 100%)",
    },
    {
      tag: "Customer service",
      heading: "Support your customers automatically",
      content:
        "Respond to customer queries quickly, cross sell and upsell effortlessly, collect reviews and feedback, and trigger real-time notifications.",
      img: broadcastImg3,
      alt: "workflows for sales and operations teams",
      background: "linear-gradient(180deg, #00B181 0%, #1448C4 100%)",
    },
    {
      tag: "Operations",
      heading: "Simplify processes, amplify productivity",
      content:
        "Boost efficiency by automating order processing, inventory management, and document approvals. Streamline meetings with automated invitations and reminders for smooth team collaboration.",
      img: broadcastImg2,
      alt: "customer support workflow",
      background: "linear-gradient(180deg, #B74AF5 0%, #5E02A8 100%)",
    },
  ];
  const faqs = [
    {
      question: "Can workflow automation integrate with my existing tools?",
      answer: (
        <>
          Yes, the workflow automation feature in Pepper Cloud CRM software
          integrates seamlessly with all your existing business tools.
        </>
      ),
    },
    {
      question: "Can workflow automation reduce operational costs?",
      answer: (
        <>
          Yes, by automating routine tasks, businesses can reduce manual labour
          costs and allocate resources more effectively.
        </>
      ),
    },
    {
      question: "Is it possible to customise workflows?",
      answer: (
        <>
          Yes, in Pepper Cloud CRM, you can customise workflows to fit your
          specific business needs. Whether automating lead nurturing,
          follow-ups, or task assignments, you can tailor every step for optimal
          efficiency.
        </>
      ),
    },
    {
      question:
        "Can Pepper Cloud CRM integrate with my existing tools and systems?",
      answer: (
        <>
          Yes, Pepper Cloud CRM seamlessly integrates with a wide range of
          tools, making it easy to automate tasks across departments and
          channels. Whether you are using email, social media, or customer
          support platforms, Pepper Cloud ensures your processes remain
          connected and efficient.
        </>
      ),
    },
    {
      question:
        "How do I choose the best CRM with workflow automation for my business?",
      answer: (
        <>
          When choosing a CRM, assess your business needs, scalability, and ease
          of use. Ensure the platform integrates with your existing tools and
          offers robust reporting and analytics. Pepper Cloud CRM stands out for
          its cost-effectiveness and seamless integration, making it a great
          choice for SMBs.
        </>
      ),
    },
    {
      question:
        "What are the top CRM platforms with workflow automation feature?",
      answer: (
        <>
          Some of the best CRM platforms for workflow automation include:
          <ul>
            <li>
              <strong>Pepper Cloud CRM:</strong> Ideal for SMBs with tailored,
              user-friendly automation and advanced analytics.
            </li>
            <li>
              <strong>Salesforce CRM:</strong> Perfect for larger enterprises
              with complex needs.
            </li>
            <li>
              <strong>HubSpot CRM:</strong> Best for businesses seeking a blend
              of marketing, sales, and service automation.
            </li>
            <li>
              <strong>Zoho CRM:</strong> An affordable solution with powerful
              automation features.
            </li>
            <li>
              <strong>Pipedrive CRM:</strong> Focused on simplifying sales tasks
              and process automation.
            </li>
          </ul>
        </>
      ),
    },
    {
      question: "What are the best practices for CRM workflow automation?",
      answer: (
        <>
          Best practices include identifying the specific workflows you want to
          automate, collaborating with teams to align automation with business
          needs, and continuously monitoring the performance of automated
          processes. Starting with a pilot project and ensuring clean data are
          also crucial steps.
        </>
      ),
    },
    {
      question:
        "Can Pepper Cloud CRM help with sales automation and lead management?",
      answer: (
        <>
          Yes, Pepper Cloud CRM automates lead nurturing, follow-ups, and task
          assignments, helping your sales team close deals faster and more
          effectively. It allows you to track leads at every stage of the
          pipeline and ensures timely, personalised communication.
        </>
      ),
    },
  ];

  return (
    <main>
      <SEO
        title={"Best CRM for Workflow Automation | Pepper Cloud"}
        pathname={"https://peppercloud.com/whatsapp-crm/"}
        keywords="workflow automation, business process automation workflow,crm workflow automation,workflow automation platform,What is workflow automation,"
        description={
          "Pepper Cloud CRM Software’s workflow automation software helps reduce manual work, speed up your sales processes and boost productivity. Create intitutive workflows now."
        }
        ogData={{
          "og:image": [
            "/meta/og/1X1/home.png",
            "/meta/og/1024X512/home.png",
            "/meta/og/1200X630/home.png",
          ],
        }}
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Pepper Cloud",
            legalName: "Pepper Cloud PTE LTD",
            url: "https://peppercloud.com/",
            logo: "https://peppercloud.com/icons/logo.png",
            foundingDate: "2017",
            address: [
              {
                "@type": "PostalAddress",
                streetAddress: "#04-01/02",
                addressLocality: "Blk 79 Ayer Rajah Crescent",
                addressRegion: "SG",
                postalCode: "139955",
                addressCountry: "Singapore",
              },
              {
                "@type": "PostalAddress",
                streetAddress:
                  "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                addressLocality: "Bengaluru",
                addressRegion: "KA",
                postalCode: "560095",
                addressCountry: "India",
              },
            ],
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              telephone: "+6566562616",
              email: ["sales@peppercloud.com", "support@peppercloud.com"],
            },
            sameAs: [
              "https://twitter.com/peppercloudpte",
              "https://www.linkedin.com/company/peppercloud/",
              "https://www.facebook.com/PepperCloudPteLtd",
              "https://www.instagram.com/pepper.cloud/",
            ],
          },
          {
            "@context": "https://schema.org/",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "Can workflow automation integrate with my existing tools?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, the workflow automation feature in Pepper Cloud CRM software integrates seamlessly with all your existing business tools.",
                },
              },
              {
                "@type": "Question",
                name: "Can workflow automation reduce operational costs?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, by automating routine tasks, businesses can reduce manual labour costs and allocate resources more effectively.",
                },
              },
              {
                "@type": "Question",
                name: "Is it possible to customise workflows?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, in Pepper Cloud CRM, you can customise workflows to fit your specific business needs. Whether automating lead nurturing, follow-ups, or task assignments, you can tailor every step for optimal efficiency.",
                },
              },
              {
                "@type": "Question",
                name: "What are the top CRM platforms with workflow automation feature?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Some of the best CRM platforms for workflow automation include: Pepper Cloud CRM: Ideal for SMBs with tailored, user-friendly automation and advanced analytics. Salesforce CRM: Perfect for larger enterprises with complex needs. HubSpot CRM: Best for businesses seeking a blend of marketing, sales, and service automation. Zoho CRM: An affordable solution with powerful automation features. Pipedrive CRM: Focused on simplifying sales tasks and process automation.",
                },
              },
              {
                "@type": "Question",
                name: "How do I choose the best CRM with workflow automation for my business?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "When choosing a CRM, assess your business needs, scalability, and ease of use. Ensure the platform integrates with your existing tools and offers robust reporting and analytics. Pepper Cloud CRM stands out for its cost-effectiveness and seamless integration, making it a great choice for SMBs.",
                },
              },
              {
                "@type": "Question",
                name: "What are the best practices for CRM workflow automation?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Best practices include identifying the specific workflows you want to automate, collaborating with teams to align automation with business needs, and continuously monitoring the performance of automated processes. Starting with a pilot project and ensuring clean data are also crucial steps.",
                },
              },
              {
                "@type": "Question",
                name: "Can Pepper Cloud CRM help with sales automation and lead management?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, Pepper Cloud CRM automates lead nurturing, follow-ups, and task assignments, helping your sales team close deals faster and more effectively. It allows you to track leads at every stage of the pipeline and ensures timely, personalised communication.",
                },
              },
            ],
          },
        ]}
      />
      <section className={classes.heroSection}>
        <div className="container">
          <div className={classes.heroSectionInner}>
            <motion.h1
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-72  font-white"
            >
              Smart <span className="highlight">workflow</span>{" "}
              <span className="highlight">automation</span> for unmatched
              productivity
            </motion.h1>
            <motion.p
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-18"
              style={{ color: "#A2BED3" }}
            >
              Supercharge your business with intelligent workflow automation in
              CRM. Automate repetitive tasks, streamline processes, and boost
              team efficiency - all while ensuring seamless operations.
            </motion.p>
            <div className="heroPoints">
              <div className="point">
                <img src={whiteCheckCircle} alt="pointer" />
                <p
                  style={{ color: "#A2BED3" }}
                  className="font-18 font-wix-medium"
                >
                  End-to-end sales automation
                </p>
              </div>
              <div className="point">
                <img src={whiteCheckCircle} alt="pointer" />
                <p
                  style={{ color: "#A2BED3" }}
                  className="font-18 font-wix-medium"
                >
                  Customisable workflows
                </p>
              </div>
              <div className="point">
                <img src={whiteCheckCircle} alt="pointer" />
                <p
                  style={{ color: "#A2BED3" }}
                  className="font-18 font-wix-medium"
                >
                  Multi-channel integration
                </p>
              </div>
            </div>
            <Link
              className="primaryButton font-18 font-wix-medium font-white"
              to="/contact/"
              target="_blank"
            >
              Book a free demo
            </Link>
          </div>
          <img
            src={workflowAutomationHero}
            alt="Workflow Automation"
            style={{ width: "100%" }}
          />
        </div>
      </section>
      <section className={classes.bodySection}>
        <div className="container">
          {/* <div className={classes.featureContainerOuter}> */}
          <div className={classes.featureContainerInner}>
            <div className={classes.featureContainerInnerHeader}>
              <p className="font-wix-semibold font-24 font-black1">
                Automate your sales, support, and operations with ease
              </p>
            </div>
            <div className={classes.featureContainerInnerBody}>
              {featureList.map((feature) => (
                <div className={classes.workflowFeatureContainer}>
                  <img
                    src={feature.icon}
                    alt={`Automate ${feature.desc}`}
                    // style={{ background: feature.color }}
                  />
                  <p className="font-18 font-wix-medium font-black1">
                    {feature.desc}
                  </p>
                </div>
              ))}
            </div>

            {/* </div> */}
          </div>
          <div className="centerContainer">
            <motion.h3
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-24 font-black1"
            >
              Best CRM with WhatsApp integration - Trusted by SMEs globally
            </motion.h3>
          </div>
        </div>
        <Swiper
          className={classes.partnerSlider}
          slidesPerView="auto"
          spaceBetween={60}
          loop={true}
          speed={2000}
          modules={[Autoplay]}
          allowTouchMove={false}
          autoplay={{
            delay: 100,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          }}
        >
          {partners.map((partner) => (
            <SwiperSlide className={classes.partnerSlide}>
              <img src={partner.icon} alt={partner.alt} />
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="container containerInner">
          <motion.div
            initial={{ opacity: 1, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            className={classes.supportBox}
            // style={{ background: point.background }}
          >
            <div className={classes.broadcastLeftContainer}>
              <p className={clsx("font-40 font-wix-medium font-white")}>
                What is workflow automation?
              </p>
              <p className="font-18 font-wix-regular font-white">
                Workflow automation simplifies and optimises key business
                processes-like capturing leads, automating follow-ups, and
                generating reports. It ensures smooth sales operations, enabling
                your team to focus on high-value tasks that drive revenue.
              </p>
              <div className={classes.pointers}>
                <div className={classes.cardPointer}>
                  <LazyImage
                    source={whiteCheckCircle}
                    className={classes.pointerImg}
                    alt={"pointer"}
                  />
                  <p className="font-wix-regular font-18 font-white">
                    Higher conversion rates
                  </p>
                </div>
                <div className={classes.cardPointer}>
                  <LazyImage
                    source={whiteCheckCircle}
                    className={classes.pointerImg}
                    alt={"pointer"}
                  />
                  <p className="font-wix-regular font-18 font-white">
                    Faster deal closures
                  </p>
                </div>
                <div className={classes.cardPointer}>
                  <LazyImage
                    source={whiteCheckCircle}
                    className={classes.pointerImg}
                    alt={"pointer"}
                  />
                  <p className="font-wix-regular font-18 font-white">
                    Greater operational efficiency
                  </p>
                </div>
              </div>
            </div>
            <div className={classes.broadcastRightContainer}>
              <LazyImage
                source={workFlowImg}
                alt={"What is workflow automation?"}
                className={classes.broadcastImg}
              />
            </div>
          </motion.div>
        </div>
      </section>
      <section className={classes.growingBusiness}>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 color-black1"
            >
              Achieve more in less time with smart workflow automation
            </motion.h2>
          </div>
        </div>
        <Swiper
          slidesPerView={3.3}
          // centeredSlides={true}
          spaceBetween={30}
          grabCursor={true}
          loop={false}
          speed={5000}
          modules={[Autoplay]}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          className={classes.broadcastContainerInner}
          breakpoints={{
            // For smaller screens (mobile)
            0: {
              slidesPerView: "auto",
              freeMode: true,
              grabCursor: false,
              spaceBetween: 10,
              autoplay: false,
              modules: [],
            },
            // For larger screens (desktop)
            768: {
              slidesPerView: "auto",
              spaceBetween: 30,
              grabCursor: true,
            },
          }}
        >
          {growingList.map((feature) => (
            <SwiperSlide
              className={classes.featureContainer}
              style={{ backgroundImage: `url(${feature.background})` }}
            >
              <p className="font-wix-semibold font-24 font-white">
                {feature.heading}
              </p>
              <div className={classes.pointers}>
                {feature.points &&
                  feature.points.map((point, index) => (
                    <div key={index} className={classes.cardPointer}>
                      <LazyImage
                        source={whiteCheckCircle}
                        className={classes.pointerImg}
                        alt={"pointer"}
                      />
                      <p className="font-wix-regular font-18 font-white">
                        {point}
                      </p>
                    </div>
                  ))}
              </div>
              <img
                src={feature.img}
                className="absoluteImg"
                alt={feature.alt}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
      <section className={classes.performanceSection}>
        <div className="container">
          <div className={classes.integrationHeader}>
            <div className={classes.integrationLeft}>
              <motion.h2
                initial={{ opacity: 1, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
                className="font-wix-medium font-56 color-black7"
              >
                Redefine efficiency with powerful CRM workflow automation
              </motion.h2>
            </div>
            <div className={classes.integrationRight}>
              <motion.p
                initial={{ opacity: 1, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
                className="font-wix-regular font-18 color-purple3"
              >
                Reduce efforts, automate processes, and boost productivity with
                seamless workflow automation. Transform how your team works and
                enable your team to focus on customer relationships.
              </motion.p>
              {/* <motion.a
                initial={{ opacity: 1, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
                className="transparentButton  font-wix-medium font-16"
              >
                More about Assist Ai
              </motion.a> */}
            </div>
          </div>
          <div className={classes.statsContainer}>
            {statsBoxContent.map((stat, index) => (
              <motion.div
                whileInView={{ opacity: [0, 1], y: [50, 0] }}
                transition={{ duration: 1, delay: index * 0.1 }}
                className={classes.statsBox}
              >
                <div className={classes.statsBoxHeader}>
                  <img
                    src={stat.icon}
                    className={classes.statIcon}
                    // style={{ backgroundColor: stat.iconBg }}
                  />
                </div>
                <div className={classes.statsBoxBody}>
                  <p
                    style={{ color: `${stat.color}` }}
                    className={clsx("font-48", "font-wix-medium")}
                  >
                    {stat.number}
                  </p>
                  <p className="font-18 color-purple3 font-wix-medium">
                    {stat.heading}
                  </p>
                  <div className="border" />
                  <p className="font-186 color-purple3 font-wix-regular">
                    {stat.content}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
          <div className={classes.belowText}>
            <p className="font-12 font-wix-regular">
              * Statistics from multiple sources
            </p>
          </div>
        </div>
      </section>
      <section className={clsx(classes.benefitSection)}>
        <div className="container">
          <div className={classes.integrationHeader}>
            <div className={classes.integrationLeft}>
              <motion.div
                initial={{ opacity: 1, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
                className="sectionTag"
              >
                <p className="font-18  font-wix-semibold color-blue1">
                  Integrations
                </p>
              </motion.div>
              <motion.h2
                initial={{ opacity: 1, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
                className="font-wix-semibold font-56 color-black1"
              >
                Streamline workflows with powerful integrations
              </motion.h2>
              <motion.p
                initial={{ opacity: 1, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
                className="font-wix-regular font-18 color-black2 mt20"
              >
                Connect your favourite tools seamlessly with CRM to automate
                repetitive tasks, trigger timely communication, and simplify
                complex processes. Stay connected with potential clients and
                team automatically with powerful integrations.
              </motion.p>
            </div>
            <div className={classes.integrationRight}>
              <img
                  alt="Smart workflow automation"
                  className={classes.integrationBg}
                  src={benefitBg}
                />
              <div className={classes.cardsLayout}>
                <div className={classes.cards}>
                  <div
                    className={classes.card}
                    onClick={() =>
                      (window.location.href =
                        "/crm-integrations/gmail-email-inbox/")
                    }
                  >
                    <div className={classes.cardHeader}>
                      <img
                        src={gmailIcon}
                        alt="Workflows for Gmail automation"
                      />
                      <img src={arrow} alt="arrowIcon" />
                    </div>

                    <p className="font-16 font-wix-semibold font-black1">
                      Gmail
                    </p>
                    <p className="font14 font-wix-regular font-black2">
                      Trigger personalised emails, follow-ups, notifications,
                      and more via Gmail.
                    </p>
                  </div>
                  <div
                    className={classes.card}
                    onClick={() =>
                      (window.location.href =
                        "/crm-integrations/microsoft-outlook-365-integration/")
                    }
                  >
                    <div className={classes.cardHeader}>
                      <img
                        src={officeIcon}
                        alt="Workflows for Outlook automation"
                      />
                      <img src={arrow} alt="arrowIcon" />
                    </div>

                    <p className="font-16 font-wix-semibold font-black1">
                      Outlook
                    </p>
                    <p className="font14 font-wix-regular font-black2">
                      Send email notifications, timely follow-ups, log
                      conversations, and more via Outlook.
                    </p>
                  </div>
                </div>
                <div className={classes.cards}>
                  <div
                    className={classes.card}
                    onClick={() => (window.location.href = "/whatsapp-crm/")}
                  >
                    <div className={classes.cardHeader}>
                      <img
                        src={whatsappIcon}
                        alt="Workflows for WhatsApp automation"
                      />
                      <img src={arrow} alt="arrowIcon" />
                    </div>

                    <p className="font-16 font-wix-semibold font-black1">
                      WhatsApp
                    </p>
                    <p className="font14 font-wix-regular font-black2">
                      Auto-send updates, confirmations, assignments, and more on
                      WhatsApp.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className={classes.broadcastContainer}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 font-white"
            >
              Experience workflow automations across departments
            </motion.h2>
          </div>
        </div>
        <Swiper
          slidesPerView={1}
          centeredSlides={true}
          spaceBetween={30}
          grabCursor={true}
          className={classes.workflowBroadcastContainerInner}
          breakpoints={{
            // For smaller screens (mobile)
            0: {
              slidesPerView: 1.1,
              slidesPerGroup: 1,
              freeMode: true,
              grabCursor: false,
              allowTouchMove: true,
              spaceBetween: 10,
            },
            // For larger screens (desktop)
            768: {
              slidesPerView: "auto",
              centeredSlides: true,
              spaceBetween: 30,
              grabCursor: true,
            },
          }}
        >
          {broadcastList.map((point, index) => (
            <SwiperSlide
              className={classes.broadcastBox}
              style={{ background: point.background }}
            >
              <div className={classes.broadcastLeftContainer}>
                <p
                  className={clsx(
                    "font-18 font-wix-semibold font-white",
                    classes.tag
                  )}
                >
                  {point.tag}
                </p>
                <p className="font-40 font-wix-medium font-white">
                  {point.heading}
                </p>
                <p className="font-18 font-wix-medium font-white">
                  {point.content}
                </p>
              </div>
              <div className={classes.broadcastRightContainer}>
                <img
                  src={point.img}
                  alt={point.alt}
                  className={classes.broadcastImg}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
      <section className={classes.trustedSection}>
        <div className="container">
          <TruestedSection background={true} />
        </div>
      </section>
      <section style={{ background: "#EBF8F7" }}>
        <TestimonialSlider
          noButton={true}
          heading={"Real stories. Real results."}
          desc={
            "Discover how businesses are transforming customer engagement with Pepper Cloud."
          }
        />
      </section>
      <div className={classes.wpFaq}>
        <FaqSection
          // backgroundColor={"#F1FFF9"}
          heading={"CRM workflow automation- FAQs"}
          faqs={faqs}
        />
      </div>
      <section className={classes.commonPageFooterSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 font-white"
            >
              Transform operations effortlessly with Pepper Cloud CRM
            </motion.h2>
            <Link
              to="/contact/"
              className="primaryButton font-20 font-wix-medium font-white"
            >
              Get started
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default WorkflowAutomation;
